export function userRolesSelector(state, storeShape) {
  return state.getIn(storeShape.user.concat(["currentUser", "roles"]));
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/selectors/external.js